import { createClient } from '@supabase/supabase-js';

const configuredProxyUrl = process.env.REACT_APP_SUPABASE_PROXY_URL;
const directUrl = process.env.REACT_APP_SUPABASE_URL;

const getSupabaseUrl = () => {
  if (!configuredProxyUrl) return directUrl;

  try {
    const proxyUrl = new URL(configuredProxyUrl, window.location.origin);

    if (proxyUrl.pathname.startsWith('/api/supabase-proxy')) {
      return `${window.location.origin}${proxyUrl.pathname}`;
    }

    return proxyUrl.href;
  } catch {
    return configuredProxyUrl;
  }
};

const supabaseUrl = getSupabaseUrl();
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Supabase URL или ключ не настроены в переменных окружения.');
}

const nativeFetch = typeof window !== 'undefined' ? window.fetch.bind(window) : fetch;

// Прокси-ответы с данными раньше кэшировались браузером на сутки.
// Версия в query-параметре сбрасывает старые записи; прокси её вырезает.
const CACHE_BUST_PARAM = '_cb';
const CACHE_BUST_VERSION = '2';

const withCacheBust = (url) => {
  if (typeof url !== 'string' || !url.includes('/api/supabase-proxy')) return url;
  if (url.includes(`${CACHE_BUST_PARAM}=`)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}${CACHE_BUST_PARAM}=${CACHE_BUST_VERSION}`;
};

const fetchWithRetry = async (input, init = {}) => {
  const method = (init.method || 'GET').toUpperCase();

  if ((method === 'GET' || method === 'HEAD') && typeof input === 'string') {
    input = withCacheBust(input);
  }

  const url = typeof input === 'string' ? input : input?.url || '';
  const canRetry = method === 'GET' || method === 'HEAD' || url.includes('/auth/v1/token');
  const attempts = canRetry ? 3 : 1;
  let lastError;

  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      return await nativeFetch(input, init);
    } catch (error) {
      lastError = error;
      if (attempt + 1 < attempts) {
        await new Promise(resolve => setTimeout(resolve, 400 * (attempt + 1)));
      }
    }
  }

  throw lastError;
};

const supabase = createClient(
  supabaseUrl,
  supabaseKey,
  {
    global: {
      fetch: fetchWithRetry,
    },
    auth: {
      persistSession: true,       // Сохраняет сессию в localStorage
      autoRefreshToken: true,     // Автоматически обновляет токены
      detectSessionInUrl: true,  // Убирает проверку сессии в URL (чтобы не мешала)
      storage: localStorage,      // Использует localStorage (не cookies)
    }
  }
);

export default supabase;